var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',[_vm._v("Courses")]),_c('ResponsiveTable',{attrs:{"headers":['Name', ''],"rows":_vm.courses}}),_c('BaseButton',{attrs:{"type":"submit","href":{name: 'AdminCoursesCreate'}}},[_vm._v(" Create course ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }